import { Link } from "react-router-dom";
import { useState } from "react";

const BlogGridInner = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 6;

  const blogPosts = [
    {
      id: 1,
      title: "Panduan Lengkap Penulisan Skripsi: Dari Proposal Hingga Sidang",
      excerpt: "Tips dan strategi menulis skripsi yang efektif, termasuk pemilihan topik, metodologi penelitian, dan persiapan sidang akhir",
      image: "assets/images/blog/panduan-skripsi.jpg",
      date: "10 Mei 2024",
      author: "Tim Vice Research",
      views: "856",
      category: "Panduan Skripsi",
      keywords: "panduan skripsi, tips menulis skripsi, metodologi penelitian, sidang skripsi"
    },
    {
      id: 2, 
      title: "Cara Menulis Jurnal Ilmiah yang Baik untuk Publikasi Internasional",
      excerpt: "Langkah-langkah detail menulis artikel jurnal berkualitas tinggi untuk publikasi di jurnal internasional bereputasi",
      image: "assets/images/blog/jurnal-internasional.jpg",
      date: "8 Mei 2024",
      author: "Tim Vice Research",
      views: "743",
      category: "Publikasi Jurnal",
      keywords: "jurnal internasional, publikasi penelitian, artikel ilmiah, scopus"
    },
    {
      id: 3,
      title: "Teknik Analisis Data Kuantitatif Menggunakan SPSS dan STATA",
      excerpt: "Panduan praktis mengolah data penelitian kuantitatif menggunakan software statistik SPSS dan STATA",
      image: "assets/images/blog/analisis-data.jpg",
      date: "5 Mei 2024",
      author: "Tim Vice Research",
      views: "921",
      category: "Metodologi Penelitian",
      keywords: "analisis data, SPSS, STATA, penelitian kuantitatif"
    },
    {
      id: 4,
      title: "Strategi Lolos Review Jurnal Scopus: Tips dari Para Reviewer",
      excerpt: "Insight dan tips dari reviewer jurnal Scopus tentang cara menyiapkan artikel yang berkualitas tinggi",
      image: "assets/images/blog/review-scopus.jpg",
      date: "3 Mei 2024",
      author: "Tim Vice Research",
      views: "678",
      category: "Publikasi Jurnal",
      keywords: "jurnal scopus, peer review, publikasi internasional"
    },
    {
      id: 5,
      title: "Panduan Penulisan Tesis: Fokus pada Metodologi dan Analisis",
      excerpt: "Tips menulis tesis yang kuat dengan penekanan pada metodologi penelitian dan analisis data yang mendalam",
      image: "assets/images/blog/panduan-tesis.jpg",
      date: "1 Mei 2024",
      author: "Tim Vice Research",
      views: "534",
      category: "Panduan Tesis",
      keywords: "penulisan tesis, metodologi penelitian, analisis data tesis"
    },
    {
      id: 6,
      title: "Teknik Wawancara dalam Penelitian Kualitatif",
      excerpt: "Metode dan strategi melakukan wawancara yang efektif dalam penelitian kualitatif",
      image: "assets/images/blog/teknik-wawancara.jpg",
      date: "28 April 2024",
      author: "Tim Vice Research",
      views: "823",
      category: "Metodologi Penelitian",
      keywords: "penelitian kualitatif, teknik wawancara, pengumpulan data"
    }
  ];

  // Pagination logic
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = blogPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(blogPosts.length / postsPerPage);

  const paginate = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      window.scrollTo(0, 0);
    }
  };

  return (
    <div className='blog-page-section py-120'>
      <div className='container'>
        <div className='flex-between gap-16 flex-wrap mb-40'>
          <span className='text-neutral-500'>Artikel Terbaru Vice Research</span>
          <div className='flex-align gap-16'>
            <div className='flex-align gap-8'>
              <span className='text-neutral-500 flex-shrink-0'>Urutkan :</span>
              <select className='form-select ps-20 pe-28 py-8 fw-medium rounded-pill bg-main-25 border border-neutral-30 text-neutral-700'>
                <option value="terbaru">Terbaru</option>
                <option value="populer">Terpopuler</option>
                <option value="kategori">Kategori</option>
              </select>
            </div>
          </div>
        </div>

        <div className='row gy-4'>
          {currentPosts.map((post) => (
            <div key={post.id} className='col-lg-4 col-sm-6'>
              <article className='scale-hover-item bg-main-25 rounded-16 p-12 h-100 border border-neutral-30'>
                <div className='course-item__thumb rounded-12 overflow-hidden position-relative'>
                  <Link to={`/blog/${post.id}`} className='w-100 h-100'>
                    <img
                      src={post.image}
                      alt={post.title}
                      className='scale-hover-item__img rounded-12 cover-img transition-2'
                    />
                  </Link>
                  <div className='position-absolute inset-inline-end-0 inset-block-end-0 me-16 mb-16 py-12 px-24 rounded-8 bg-main-three-600 text-white fw-medium'>
                    <span className='mb-0 text-white fw-medium'>{post.date}</span>
                  </div>
                </div>
                <div className='pt-32 pb-24 px-16 position-relative'>
                  <h4 className='mb-28'>
                    <Link to={`/blog/${post.id}`} className='link text-line-2'>
                      {post.title}
                    </Link>
                  </h4>
                  <p className='text-neutral-500 text-line-2 mb-20'>
                    {post.excerpt}
                  </p>
                  <div className='flex-align gap-14 flex-wrap my-20'>
                    <div className='flex-align gap-8'>
                      <span className='text-neutral-500 text-2xl d-flex'>
                        <i className='ph ph-user-circle' />
                      </span>
                      <span className='text-neutral-500 text-lg'>
                        {post.author}
                      </span>
                    </div>
                    <span className='w-8 h-8 bg-neutral-100 rounded-circle' />
                    <div className='flex-align gap-8'>
                      <span className='text-neutral-500 text-2xl d-flex'>
                        <i className='ph-bold ph-tag' />
                      </span>
                      <span className='text-neutral-500 text-lg'>
                        {post.category}
                      </span>
                    </div>
                    <span className='w-8 h-8 bg-neutral-100 rounded-circle' />
                    <div className='flex-align gap-8'>
                      <span className='text-neutral-500 text-2xl d-flex'>
                        <i className='ph-bold ph-eye' />
                      </span>
                      <span className='text-neutral-500 text-lg'>{post.views}</span>
                    </div>
                  </div>
                  <div className='flex-between gap-8 pt-24 border-top border-neutral-50 mt-28 border-dashed border-0'>
                    <Link
                      to={`/blog/${post.id}`}
                      className='flex-align gap-8 text-main-600 hover-text-decoration-underline transition-1 fw-semibold'
                      aria-label={`Baca selengkapnya tentang ${post.title}`}
                    >
                      Baca Selengkapnya
                      <i className='ph ph-arrow-right' />
                    </Link>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>

        <ul className='pagination mt-40 flex-align gap-12 flex-wrap justify-content-center'>
          <li className='page-item'>
            <button
              className='page-link text-neutral-700 fw-semibold w-40 h-40 bg-main-25 rounded-circle hover-bg-main-600 border-neutral-30 hover-border-main-600 hover-text-white flex-center p-0'
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <i className='ph-bold ph-caret-left' />
            </button>
          </li>
          
          {[...Array(totalPages)].map((_, index) => (
            <li key={index} className='page-item'>
              <button
                className={`page-link text-neutral-700 fw-semibold w-40 h-40 rounded-circle border-neutral-30 hover-border-main-600 hover-text-white flex-center p-0 ${
                  currentPage === index + 1 ? 'bg-main-600 text-white' : 'bg-main-25'
                }`}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </button>
            </li>
          ))}

          <li className='page-item'>
            <button
              className='page-link text-neutral-700 fw-semibold w-40 h-40 bg-main-25 rounded-circle hover-bg-main-600 border-neutral-30 hover-border-main-600 hover-text-white flex-center p-0'
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <i className='ph-bold ph-caret-right' />
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BlogGridInner;
